import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { responseConfigurationPageAccessControl } from '../access-control/responseConfigurationPageAccess.configuration'

const ResponseConfigurationsListPage = lazy(
  () => import('../pages/ResponseConfigurationsListPage/page')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const fulfillmentPartnerIntegrationsRouter = (
  <DomainRoute route="fulfillment-partner-integrations">
    <DashSwitch>
      <DomainRoute
        exact
        route="fulfillment-partner-integrations-response-configurations-list"
        component={ResponseConfigurationsListPage}
        accessControl={responseConfigurationPageAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
